import {
  OperationParameter,
  OperationURLParameter,
  OperationQueryParameter,
} from "@azure/core-client";
import {
  CustomizationTaskList as CustomizationTaskListMapper,
  DevBox as DevBoxMapper,
  CustomizationGroup as CustomizationGroupMapper,
  Environment as EnvironmentMapper,
  EnvironmentPatchProperties as EnvironmentPatchPropertiesMapper,
} from "../models/mappers";

export const accept: OperationParameter = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "application/json",
    isConstant: true,
    serializedName: "Accept",
    type: {
      name: "String",
    },
  },
};

export const endpoint: OperationURLParameter = {
  parameterPath: "endpoint",
  mapper: {
    serializedName: "endpoint",
    required: true,
    type: {
      name: "String",
    },
  },
  skipEncoding: true,
};

export const apiVersion: OperationQueryParameter = {
  parameterPath: "apiVersion",
  mapper: {
    defaultValue: "2024-10-01-preview",
    isConstant: true,
    serializedName: "api-version",
    type: {
      name: "String",
    },
  },
};

export const projectName: OperationURLParameter = {
  parameterPath: "projectName",
  mapper: {
    constraints: {
      Pattern: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-_.]{2,62}$"),
      MaxLength: 63,
      MinLength: 3,
    },
    serializedName: "projectName",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const catalogName: OperationURLParameter = {
  parameterPath: "catalogName",
  mapper: {
    constraints: {
      Pattern: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-_.]{2,62}$"),
      MaxLength: 63,
      MinLength: 3,
    },
    serializedName: "catalogName",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const taskName: OperationURLParameter = {
  parameterPath: "taskName",
  mapper: {
    serializedName: "taskName",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const contentType: OperationParameter = {
  parameterPath: ["options", "contentType"],
  mapper: {
    defaultValue: "application/json",
    isConstant: true,
    serializedName: "Content-Type",
    type: {
      name: "String",
    },
  },
};

export const body: OperationParameter = {
  parameterPath: "body",
  mapper: CustomizationTaskListMapper,
};

export const accept1: OperationParameter = {
  parameterPath: "accept",
  mapper: {
    defaultValue: "text/plain, application/json",
    isConstant: true,
    serializedName: "Accept",
    type: {
      name: "String",
    },
  },
};

export const imageBuildLogId: OperationURLParameter = {
  parameterPath: "imageBuildLogId",
  mapper: {
    serializedName: "imageBuildLogId",
    required: true,
    type: {
      name: "Uuid",
    },
  },
};

export const poolName: OperationURLParameter = {
  parameterPath: "poolName",
  mapper: {
    constraints: {
      Pattern: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-_.]{2,62}$"),
      MaxLength: 63,
      MinLength: 3,
    },
    serializedName: "poolName",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const scheduleName: OperationURLParameter = {
  parameterPath: "scheduleName",
  mapper: {
    constraints: {
      Pattern: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-_.]{2,62}$"),
      MaxLength: 63,
      MinLength: 3,
    },
    serializedName: "scheduleName",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const userId: OperationURLParameter = {
  parameterPath: "userId",
  mapper: {
    constraints: {
      Pattern: new RegExp(
        "^[a-zA-Z0-9]{8}-([a-zA-Z0-9]{4}-){3}[a-zA-Z0-9]{12}$|^me$",
      ),
      MaxLength: 36,
      MinLength: 2,
    },
    serializedName: "userId",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const devBoxName: OperationURLParameter = {
  parameterPath: "devBoxName",
  mapper: {
    constraints: {
      Pattern: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-_.]{2,62}$"),
      MaxLength: 63,
      MinLength: 3,
    },
    serializedName: "devBoxName",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const body1: OperationParameter = {
  parameterPath: "body",
  mapper: DevBoxMapper,
};

export const hibernate: OperationQueryParameter = {
  parameterPath: ["options", "hibernate"],
  mapper: {
    serializedName: "hibernate",
    type: {
      name: "Boolean",
    },
  },
};

export const snapshotId: OperationQueryParameter = {
  parameterPath: "snapshotId",
  mapper: {
    serializedName: "snapshotId",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const actionName: OperationURLParameter = {
  parameterPath: "actionName",
  mapper: {
    constraints: {
      Pattern: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-_.]{2,62}$"),
      MaxLength: 63,
      MinLength: 3,
    },
    serializedName: "actionName",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const delayUntil: OperationQueryParameter = {
  parameterPath: "delayUntil",
  mapper: {
    serializedName: "until",
    required: true,
    type: {
      name: "DateTime",
    },
  },
};

export const include: OperationQueryParameter = {
  parameterPath: ["options", "include"],
  mapper: {
    serializedName: "include",
    type: {
      name: "String",
    },
  },
};

export const customizationGroupName: OperationURLParameter = {
  parameterPath: "customizationGroupName",
  mapper: {
    constraints: {
      Pattern: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-_.]{2,62}$"),
      MaxLength: 63,
      MinLength: 3,
    },
    serializedName: "customizationGroupName",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const body2: OperationParameter = {
  parameterPath: "body",
  mapper: CustomizationGroupMapper,
};

export const customizationTaskId: OperationURLParameter = {
  parameterPath: "customizationTaskId",
  mapper: {
    constraints: {
      Pattern: new RegExp(
        "^[a-zA-Z0-9]{8}-([a-zA-Z0-9]{4}-){3}[a-zA-Z0-9]{12}$",
      ),
      MaxLength: 36,
      MinLength: 36,
    },
    serializedName: "customizationTaskId",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const operationId: OperationURLParameter = {
  parameterPath: "operationId",
  mapper: {
    serializedName: "operationId",
    required: true,
    type: {
      name: "Uuid",
    },
  },
};

export const snapshotId1: OperationURLParameter = {
  parameterPath: "snapshotId",
  mapper: {
    serializedName: "snapshotId",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const nextLink: OperationURLParameter = {
  parameterPath: "nextLink",
  mapper: {
    serializedName: "nextLink",
    required: true,
    type: {
      name: "String",
    },
  },
  skipEncoding: true,
};

export const projectName1: OperationURLParameter = {
  parameterPath: "projectName",
  mapper: {
    constraints: {
      Pattern: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-]{2,62}$"),
      MaxLength: 63,
      MinLength: 3,
    },
    serializedName: "projectName",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const definitionName: OperationURLParameter = {
  parameterPath: "definitionName",
  mapper: {
    constraints: {
      Pattern: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-_.]{2,62}$"),
      MaxLength: 63,
      MinLength: 3,
    },
    serializedName: "definitionName",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const environmentTypeName: OperationURLParameter = {
  parameterPath: "environmentTypeName",
  mapper: {
    constraints: {
      Pattern: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-_.]{2,62}$"),
      MaxLength: 63,
      MinLength: 3,
    },
    serializedName: "environmentTypeName",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const top: OperationQueryParameter = {
  parameterPath: ["options", "top"],
  mapper: {
    serializedName: "top",
    type: {
      name: "Number",
    },
  },
};

export const environmentName: OperationURLParameter = {
  parameterPath: "environmentName",
  mapper: {
    constraints: {
      Pattern: new RegExp("^[a-zA-Z0-9][a-zA-Z0-9-_.]{2,62}$"),
      MaxLength: 63,
      MinLength: 3,
    },
    serializedName: "environmentName",
    required: true,
    type: {
      name: "String",
    },
  },
};

export const body3: OperationParameter = {
  parameterPath: "body",
  mapper: EnvironmentMapper,
};

export const contentType1: OperationParameter = {
  parameterPath: ["options", "contentType"],
  mapper: {
    defaultValue: "application/merge-patch+json",
    isConstant: true,
    serializedName: "Content-Type",
    type: {
      name: "String",
    },
  },
};

export const body4: OperationParameter = {
  parameterPath: "body",
  mapper: EnvironmentPatchPropertiesMapper,
};

export const force: OperationQueryParameter = {
  parameterPath: ["options", "force"],
  mapper: {
    serializedName: "force",
    type: {
      name: "Boolean",
    },
  },
};

export const until: OperationQueryParameter = {
  parameterPath: "until",
  mapper: {
    serializedName: "until",
    required: true,
    type: {
      name: "DateTime",
    },
  },
};

export const operationId1: OperationURLParameter = {
  parameterPath: "operationId",
  mapper: {
    constraints: {
      Pattern: new RegExp(
        "^[a-zA-Z0-9]{8}-([a-zA-Z0-9]{4}-){3}[a-zA-Z0-9]{12}$",
      ),
      MaxLength: 36,
      MinLength: 36,
    },
    serializedName: "operationId",
    required: true,
    type: {
      name: "String",
    },
  },
};
